/* lcs-headings-kitchens.js — Kitchens headings fix (H1 único + UI demote + decor labels) */
(function () {
  var DEBUG = true;
  function log(){ if (DEBUG && window.console) try{ console.log.apply(console, arguments);}catch(_){} }

  /* ---- Guard: solo en /pages/kitchens ---- */
  var onKitchens = /\/pages\/kitchens(?:\/|$)/i.test(location.pathname);
  if (!onKitchens) { log('[LCS-K] skip — not kitchens:', location.pathname); return; }
  log('[LCS-K] running on', location.pathname, 'tpl:', (document.body.className||'').match(/template-([a-z0-9\-.]+)/i));

  /* ---- Utils ---- */
  function toPresentational(h){
    if(!h || !/^H[1-6]$/i.test(h.tagName)) return;
    try{
      var d = document.createElement('div');
      for (var i=0;i<h.attributes.length;i++){ var a=h.attributes[i]; d.setAttribute(a.name,a.value); }
      d.className = (d.className? d.className+' ' : '') + 'ui-heading';
      d.setAttribute('role','presentation'); d.setAttribute('aria-hidden','true');
      while (h.firstChild) d.appendChild(h.firstChild);
      h.replaceWith(d);
      log('[LCS-K] demoted', h.tagName, '→ DIV');
    }catch(e){}
  }
  function retagKeep(el, tag){
    if (!el || el.tagName.toLowerCase() === tag) return el;
    var n = document.createElement(tag);
    for (var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; n.setAttribute(a.name,a.value); }
    while (el.firstChild) n.appendChild(el.firstChild);
    el.replaceWith(n);
    return n;
  }

  /* ---- 1) Degradar headings de UI (header/drawers/modales/busqueda/quickshop) ---- */
  var UI_SCOPES = [
    '#shopify-section-header','header','.site-header','.header',
    '.drawer','.modal','.modal__content',
    '.cart-drawer','#CartDrawer','.cart-notification','#CartNotification','.ajaxcart','.mini-cart',
    '.predictive-search','[data-predictive-search]',
    '.quickshop','.quick-add','.quick-add-modal','.product-quickshop','#dialogQuickShopTitle'
  ];
  var UI_SELECTOR = UI_SCOPES.map(function(s){
    return s+' h1,'+s+' h2,'+s+' h3,'+s+' h4,'+s+' h5,'+s+' h6';
  }).join(',');

  function fixUI(root){
    (root||document).querySelectorAll(UI_SELECTOR).forEach(toPresentational);
  }

  /* ---- 2) Headings vacíos → presentacionales ---- */
  function fixEmpty(root){
    (root||document).querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var t = (h.textContent||'').replace(/\s+/g,'').trim();
      if (!t.length) toPresentational(h);
    });
  }

  /* ---- 3) Degradar labels decorativos (Cart / Menu / Quick shop) en TODA la página ---- */
  var DECOR_RX = /^(cart|menu|quick\s*shop)$/i;
  function fixDecor(root){
    (root||document).querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var tx=(h.textContent||'').trim().toLowerCase().replace(/\s+/g,' ');
      if (DECOR_RX.test(tx)) toPresentational(h);
    });
  }

  /* ---- 4) Semántica Kitchens ---- */
  function fixKitchens(){
    var main = document.querySelector('main') || document;
    var hero = document.querySelector('.s-header, .banner, .hero, [data-section-type*="banner"]') || document;

    // a) “OUR KITCHENS” → H1
    var claim = null;
    hero.querySelectorAll('h1,h2,h3,h4,h5,h6,.s-header__title,.s-header__heading,.section__title')
      .forEach(function(n){
        var txt = (n.textContent||'').trim().toLowerCase();
        if (!claim && /our\s+kitchens/.test(txt)) claim = n;
      });
    if (claim){
      claim = retagKeep(claim,'h1');
      claim.id = 'page-title';
      claim.setAttribute('aria-level','1');
      log('[LCS-K] Claim → H1');
    }

    // b) “Off Peak Hour Pricing” → H2
    var off = null;
    main.querySelectorAll('h1,h2,h3,h4,h5,h6,.title,.section__title').forEach(function(n){
      var t=(n.textContent||'').trim().toLowerCase();
      if (!off && /off\s*peak.*pricing/.test(t)) off=n;
    });
    if (off){
      off = retagKeep(off,'h2');
      log('[LCS-K] Off-Peak → H2');
    }

    // c) Garantizar H1 único
    var canonical = document.getElementById('page-title');
    main.querySelectorAll('h1').forEach(function(h){
      if (canonical && h!==canonical){ retagKeep(h,'h2'); log('[LCS-K] extra H1 → H2'); }
    });
  }

  /* ---- Lanzadores ---- */
  function run(){ fixUI(); fixEmpty(); fixDecor(); fixKitchens(); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  new MutationObserver(function(muts){
    muts.forEach(function(m){
      (m.addedNodes||[]).forEach(function(n){
        if (n && n.nodeType===1){ fixUI(n); fixEmpty(n); fixDecor(n); fixKitchens(); }
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
